<ion-header>
  <ion-toolbar mode="md">
    <!-- close() yerine goBack() kullanacağız -->
    <ion-button (click)="goBack()" fill="clear" slot="start" color="white" class="ion-no-padding">
      <ion-icon slot="icon-only" name="chevron-back"></ion-icon>
    </ion-button>

    <ion-title color="white" *ngIf="!live && request">

      <ion-avatar>
        <img [src]="header.image_url || 'assets/svg/profile-img.svg'" />
      </ion-avatar>

      {{request.menu_item_name | caption | translate}}
    </ion-title>

    <ion-title color="white" *ngIf="live">

      <ion-avatar>
        <ion-icon name="headset-outline" color="white"></ion-icon>
      </ion-avatar>

      {{'Live Chat' | translate}}
    </ion-title>

    <!-- <ion-button (click)="close()" color="white" expand="block" fill="clear" slot="end">
      <ion-icon slot="icon-only" name="information-circle-outline"></ion-icon>
    </ion-button> -->
  </ion-toolbar>
</ion-header>

<ion-content #content>
  <ion-grid>

    <ion-row *ngIf="request">
      <ion-col size="12">
        <ion-card>
          <!-- <img src="assets/img/logo-outline.svg"> -->
          <ion-card-header>
            <ion-card-title>{{request.menu_item_name | caption}} - {{request.requestlines[0].name | caption}}</ion-card-title>
            <ion-card-subtitle color="primary">
              {{request.order_date | date:'dd/MM/yyyy HH:mm'}}
            </ion-card-subtitle>

            <ion-text color="dark">
              {{'Status' | translate}}: <b>{{request.status | lowercase | caption | translate}}</b>
              <ng-container *ngIf="(request.requestlines | totalAmount) > 0">
                <br>
                {{'Total Amount' | translate}}: <b>{{request.requestlines[0].currency_code}}{{request.requestlines |
                  totalAmount}}</b>
              </ng-container>
            </ion-text>

            <ion-button class="detail-button" (click)="requestDetail = !requestDetail" expand="block" fill="clear">
              {{'Details' | translate}}
            </ion-button>
          </ion-card-header>
          <ion-card-content *ngIf="requestDetail">
            <ion-list>
              <ion-item *ngFor="let line of request.requestlines">
                <ion-label text-wrap>
                  {{line.quantity}} x <b><span [innerHtml]="line.name.slice(0,18)"></span><span
                      *ngIf="line.name.length>18">...</span> <span *ngIf="line.unit_of_measure">(<span
                        [innerHtml]="line.unit_of_measure"></span>)</span></b>
                  <span class="ion-float-right">
                    <b>{{line.currency_code}}{{line.amount}}</b></span>
                </ion-label>
              </ion-item>
            </ion-list>
          </ion-card-content>

        </ion-card>
      </ion-col>
    </ion-row>
    <ng-container *ngFor="let msg of records; let i = index">
      <ion-row *ngIf="i == 0 && surveyServ.surveyMessage$ | async as surveyMessage">
        <ion-col size="12" class="pt-0" *ngIf="surveyMessage.title">
          <ion-card class="survey">
            <!-- <img src="assets/img/logo-outline.svg"> -->
            <ion-card-header>
              <ion-card-title>{{surveyMessage.title | caption}}</ion-card-title>
              <ion-text color="primary">
                {{surveyMessage.description | caption}}
              </ion-text>

              <ion-button expand="block" (click)="survey(surveyMessage)" fill="solid" class="mt-3">
                {{"Take Survey" | translate}}
              </ion-button>

            </ion-card-header>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row class="message-row">

        <ng-container *ngIf="msg.user_type === 'user'; else user">
          <ion-col size="10" class="d-flex flex-row">
            <ion-item class="chat staff">
              <ion-text color="primary">
                <ng-container *ngIf="!textTranslated[i];else translatedMessage">
                  {{msg.message}}
                </ng-container>

                <ng-template #translatedMessage>{{translateTexts[i]}}
                </ng-template>

                <ion-text color="medium">
                  <small>{{msg.created_at | date:'dd/MM/yyyy HH:mm'}}</small>
                </ion-text>
              </ion-text>
            </ion-item>
            <div class="translate">
              <button class="btn translate-button" (click)="translateThisMessage(i)" *ngIf="isMultipleLang">

                <ng-container *ngIf="!showSuccessIcon[i];else success">
                  <ion-icon name="language"></ion-icon>
                </ng-container>
                <ng-template #success>
                  <ion-icon name="checkmark"></ion-icon>
                </ng-template>

              </button>
            </div>
          </ion-col>
        </ng-container>

        <ng-template #user>
          <ion-col size="10" offset="2">
            <ion-item class="chat user">
              <ion-text color="white">
                {{msg.message}}
                <ion-text color="light">
                  <small>{{msg.created_at | date:'dd/MM/yyyy HH:mm'}}</small>
                </ion-text>
              </ion-text>
            </ion-item>
          </ion-col>
        </ng-template>


      </ion-row>


    </ng-container>
  </ion-grid>
</ion-content>

<ion-footer>
  <ion-item *ngIf="dataServ.rData.show_chat && !dataServ.rData.guests_cannot_send_messages">
    <ion-textarea  (keyUp.enter)="postMessage(messageInput)"
      #messageInput (keyup)="content.scrollToBottom()"
      [rows]="messageInput.value ? (messageInput.value.length / 40 < 5 ? messageInput.value.length / 40 : 5) : 1"
      type="text" placeholder="{{'Your Message' | translate}}..."></ion-textarea>
    <ion-button [disabled]="processing" slot="end" (click)="postMessage(messageInput)" fill="clear" color="primary">
      <ion-icon slot="icon-only" name="send-outline" *ngIf="!processing"></ion-icon>
      <ion-spinner name="lines" slot="icon-only" *ngIf="processing"></ion-spinner>
    </ion-button>
  </ion-item>
</ion-footer>